import { all } from "redux-saga/effects";
import authSaga from "./component/data/saga";
export default function* rootSaga() {
    yield all([authSaga()]);
}